module.exports = __webpack_public_path__ + "static/logo-e7e325cf3da484287569beeda0ac1f91.svg";